import { Feature } from '@tencent/workbench';
import BaseMobileContextMenuFeature from '@framework/workbench/common/feature/base-mobile-context-feature';
import { config } from './config';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { REPORT_LOCATION } from '@src/slide/application/service/ai-replace-slide/ai-replace-slide-service.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { RegionType } from '@src/slide/domain/selection/constant/region';
import { getToggleStatusByType, ToggleType } from '@src/slide/infrastructure/module/dependent/config/toggle-config';
import {
    IUserPriviledgeService,
} from '@src/slide/application/service/user-priviledge-service/user-priviledge-service.interface';

declare global {
    interface Window {
        isEditing: boolean;
    }
}

@Feature()
export class AIReplaceSlideFeature extends BaseMobileContextMenuFeature {
    id = config.name;

    public showPanel() {
        const isPreviewMode = !this.getAppServices().viewableServiceLayer.entryStateService.checkIfEditMode?.();
        if (isPreviewMode) {
            // 在移动端预览页
            this.getAppServices()
                .editableServiceLayer?.mobileAIReplaceSlideService?.promise()
                .then(service => service.showPanelInPreview());
            tdw({
                opername: TDWOperationType.DOC_PPT_AI,
                module: TDWModuleType.PAGE_BEAUTY,
                action: TDWActionType.CLK,
                ver5: TDWModuleType.MOBILE,
                ver6: REPORT_LOCATION.mobilePreview,
            });
            return;
        }
        this.getAppServices()
            .editableServiceLayer?.mobileAIReplaceSlideService?.promise()
            .then(service => service.showPanel());

        const { lastMouseDownRegion } = this.getAppServices().viewableServiceLayer.selectionService;
        if (lastMouseDownRegion === RegionType.EDITOR) {
            tdw({
                opername: TDWOperationType.DOC_PPT_AI,
                module: TDWModuleType.PAGE_BEAUTY,
                action: TDWActionType.CLK,
                ver5: TDWModuleType.MOBILE,
                ver6: REPORT_LOCATION.mobileSlide,
            });
        }
        if (lastMouseDownRegion === RegionType.SLIDELIST) {
            tdw({
                opername: TDWOperationType.DOC_PPT_AI,
                module: TDWModuleType.PAGE_BEAUTY,
                action: TDWActionType.CLK,
                ver5: TDWModuleType.MOBILE,
                ver6: REPORT_LOCATION.mobileSlideList,
            });
        }
    }

    public canShowPanel() {
        if (!getToggleStatusByType(ToggleType.AI_REPLACE_SLIDE)) {
            return false;
        }
        if (!this.getAppServices().editableServiceLayer?.aiController.checkIsSupportAIEdit()) {
            return false;
        }

        const isPreviewMode = !this.getAppServices().viewableServiceLayer.entryStateService.checkIfEditMode?.();
        if (isPreviewMode && this.getUserPriviledgeService().isEditable()) {
            // 在移动端预览页，并且有编辑权限，才可以显示面板
            tdw({
                opername: TDWOperationType.DOC_PPT_AI,
                module: TDWModuleType.PAGE_BEAUTY,
                action: TDWActionType.VIEW,
                ver5: TDWModuleType.MOBILE,
                ver6: REPORT_LOCATION.mobilePreview,
            });
            return true;
        }

        const model = this.getAppServices().viewableServiceLayer.selectionService.selectedElements.getCurrentModel();
        const { lastMouseDownRegion } = this.getAppServices().viewableServiceLayer.selectionService;
        if (lastMouseDownRegion === RegionType.EDITOR && model.type === UIModelType.EMPTY) {
            tdw({
                opername: TDWOperationType.DOC_PPT_AI,
                module: TDWModuleType.PAGE_BEAUTY,
                action: TDWActionType.VIEW,
                ver5: TDWModuleType.MOBILE,
                ver6: REPORT_LOCATION.mobileSlide,
            });
            return true;
        }
        if (lastMouseDownRegion === RegionType.SLIDELIST) {
            tdw({
                opername: TDWOperationType.DOC_PPT_AI,
                module: TDWModuleType.PAGE_BEAUTY,
                action: TDWActionType.VIEW,
                ver5: TDWModuleType.MOBILE,
                ver6: REPORT_LOCATION.mobileSlideList,
            });
            return true;
        }
        return false;
    }

    private getUserPriviledgeService(): IUserPriviledgeService {
        return this.getAppServices().viewableServiceLayer.userPriviledgeService;
    }
}
